import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {SeguridadService} from '@services/index';

export const ValidarTokenGuard: CanActivateFn = () => {

    const seguridadService = inject(SeguridadService);
    const router = inject(Router);
    const negocio = seguridadService.obtenerNegocio();

    if (seguridadService.estaLogueado() && negocio === "SMI") {
        return true;
    }

    router.navigate(['/']);
    return false;
}
